import { render } from "./EmployeeReviewPeriodListModal.vue?vue&type=template&id=22355c9f&scoped=true"
import script from "./EmployeeReviewPeriodListModal.vue?vue&type=script&lang=js"
export * from "./EmployeeReviewPeriodListModal.vue?vue&type=script&lang=js"

import "./EmployeeReviewPeriodListModal.vue?vue&type=style&index=0&id=22355c9f&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22355c9f"]])

export default __exports__